var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { RESET_ANSWERS, SET_ANSWER, SET_INDEX, SET_QUESTIONS } from '../actions/questionnaire';
export var questionnaireReducer = function (state, action) {
    switch (action.type) {
        case SET_ANSWER: {
            var exists = state.selectedAnswers.some(function (answer) { return answer.questionId === action.answer.questionId; });
            var updatedAnswers = state.selectedAnswers.map(function (answer) {
                return answer.questionId === action.answer.questionId ? action.answer : answer;
            });
            var selectedAnswers = exists
                ? updatedAnswers
                : __spreadArray(__spreadArray([], state.selectedAnswers, true), [action.answer], false);
            return __assign(__assign({}, state), { selectedAnswers: selectedAnswers });
        }
        case SET_INDEX:
            return __assign(__assign({}, state), { index: action.index });
        case SET_QUESTIONS:
            return __assign(__assign({}, state), { questions: action.questions });
        case RESET_ANSWERS:
            return __assign(__assign({}, state), { selectedAnswers: [], index: 0 });
        default:
            return state;
    }
};
//# sourceMappingURL=questionnaire.js.map